import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import useStyles from 'isomorphic-style-loader/useStyles';
import classNames from 'classnames';
import NoSsr from '@material-ui/core/NoSsr';

// app modules: constants
import { MARKETING_VIDEO_ID, MARKETING_VIDEO_SERVICE } from 'constants/index';

// app: assets
import CssInlinePaywall from './InlinePaywall.scss';

const Videos = React.lazy(() => import(/* webpackChunkName: 'videos' */ 'components/Videos'));

function DualColumnPaywallContent(props) {
  const { rightContent, withWrap, even } = props;
  useStyles(CssInlinePaywall);
  const displayType = useSelector(state => state.dimensions.displayType);
  const colClassName = classNames('inline-paywall__col', { 'inline-paywall__col--even': even });
  return displayType === 'desktop' || withWrap ? (
    <div className="inline-paywall__columns">
      <div className={colClassName}>{props.children}</div>
      <div className={colClassName}>{rightContent}</div>
    </div>
  ) : (
    <div className="inline-paywall__col">{props.children}</div>
  );
}

DualColumnPaywallContent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  even: PropTypes.bool,
  rightContent: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  withWrap: PropTypes.bool,
};

DualColumnPaywallContent.defaultProps = {
  even: false,
  withWrap: false,
  rightContent: (
    <NoSsr>
      <Suspense fallback={null}>
        <Videos
          className="inline-paywall__video"
          videos={[
            {
              service: MARKETING_VIDEO_SERVICE,
              id: MARKETING_VIDEO_ID,
              autoplay: false,
              loop: false,
              muted: true,
            },
          ]}
        />
      </Suspense>
    </NoSsr>
  ),
};

export default React.memo(DualColumnPaywallContent);
